<template>
  <div>
    <CPagination
        v-show="!onlyNew"
        :active-page.sync="currentPage"
        :pages="lastPage"
        responsive
    />

    <CCol sm="12" md="12">
      <CRow>
        <CButton size="lg" color="success" block v-if="onlyNew" v-on:click="filterChange()">Загрузить еще<span v-if="remainingCount"> ({{ remainingCount }})</span></CButton>
      </CRow>
      <hr/>
    </CCol>

    <CCol sm="12" md="12">
      <CCard>
        <CCardHeader><CIcon name="cil-check"/> Фильтр</CCardHeader>
        <CCardBody>
          <CCol sm="12" md="6" lg="4">
            Только в рейтинге:
            <CSwitch
                class="mx-1"
                color="primary"
                name="switch1"
                :checked.sync="onlyInRating"

            />
          </CCol>
          <CCol sm="12" md="6" lg="4">
            Только непросмотренные:
            <CSwitch
                class="mx-1"
                color="info"
                name="switch1"
                :checked.sync="onlyNew"

            />
          </CCol>

        </CCardBody>
      </CCard>
    </CCol>

    <CRow v-show="isLoading" class="justify-content-center">
      <div class="sk-wave">
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CRow>

    <CRow v-show="!isLoading">
      <youtube-video-card
          v-for="video in videos"
          v-bind="video"
          v-bind:group_name="video.group ? video.group.name : ''"
          v-bind:key="video.id"
      />
    </CRow>

    <CPagination
        v-show="!onlyNew"
        :active-page.sync="currentPage"
        :pages="lastPage"
        responsive
    />

    <CCol sm="12" md="12">
      <CRow>
        <CButton size="lg" color="success" block v-if="onlyNew" v-on:click="filterChange()">Загрузить еще<span v-if="remainingCount"> ({{ remainingCount }})</span></CButton>
      </CRow>
      <hr/>
    </CCol>
  </div>

</template>

<style src="spinkit/spinkit.css" lang="css" />

<script>
import YoutubeVideoCard from '@/views/videos/YoutubeVideoCard';

export default {
  name: 'VideosIndex',
  components: {YoutubeVideoCard},
  data () {
    return {
      videos: [],
      currentPage: 1,
      lastPage: 1,
      isLoading: true,
      onlyInRating: false,
      onlyNew: true,
      remainingCount: 0,
    };
  },
  mounted () {
    this.loadPage();
  },
  methods: {
    loadPage () {
      this.isLoading = true;
      let params = {};
      params.page = this.currentPage;
      if (this.onlyInRating) {
        params.in_rating = 1;
      }
      if (this.onlyNew) {
        params.new = 1;
      }
      this.$http.get('/api/videos', {
        params: params,
      }).then(response => {
        this.videos = response.data.data;
        this.lastPage = response.data.meta.last_page;
        this.remainingCount = Math.max(0, response.data.meta.total - response.data.meta.per_page);
        this.isLoading = false;
      });
    },
    filterChange () {
      if (this.currentPage === 1) {
        this.loadPage();
      } else {
        this.currentPage = 1;
      }
    }
  },
  watch: {
    currentPage: function () {
      this.loadPage();
    },
    onlyInRating: function () {
      this.filterChange();
    },
    onlyNew: function () {
      this.filterChange();
    },
  },
};
</script>

<style scoped>

</style>